export const IButtonActions = {
  speedDown: 'speedDown',
  speedUp: 'speedUp',
  refresh: 'refresh',
  togglePlay: 'togglePlay',
  nextStep: 'nextStep',
  createRandomMatrix: 'createRandomMatrix'
}